export default {
    actions: { viewAll: "הצג הכול", close: "סגור", add: "הוסף", buyAgain: "קנה שוב", retry: "נסה שוב" },
    status: { loading: "טוען…", error: "משהו השתבש" },
    accessibility: { openMenu: "פתח תפריט", close: "סגור", increaseQuantity: "הגדל כמות", decreaseQuantity: "הקטן כמות", quickAdd: "הוסף במהירות לעגלה" }
} as const;
